var React = require('react');

function Integration (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"40","cy":"40","r":"40","fill":"#EDF8FF","key":0}),React.createElement("circle",{"cx":"28","cy":"52","r":"6","stroke":"#2665F6","strokeWidth":"3","key":1}),React.createElement("path",{"d":"M58 39L58 49C58 50.6569 56.6569 52 55 52L40 52M40 52L44 56M40 52L44 48","stroke":"#2665F6","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M22 41L22 31C22 29.3431 23.3431 28 25 28L40 28M40 28L36 24M40 28L36 32","stroke":"#2665F6","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":3}),React.createElement("circle",{"cx":"52","cy":"28","r":"6","stroke":"#2665F6","strokeWidth":"3","key":4})]);
}

Integration.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none"};

module.exports = Integration;

Integration.default = Integration;
